import { cssGenerator, view } from '@yola/ws-sdk';
import { ALL_DEVICES_BREAKPOINT } from '../constants/visibility';

const { HIDDEN } = cssGenerator.constants.classNames;

export const hasHiddenClassAt = (classValue, breakpoint) => {
  if (!classValue) return false;

  return classValue
    .split(' ')
    .some((token) => view.helpers.matchesResponsiveToken(token, HIDDEN, breakpoint));
};

const isHiddenAt = (classValue, breakpoint) =>
  hasHiddenClassAt(classValue, ALL_DEVICES_BREAKPOINT) || hasHiddenClassAt(classValue, breakpoint);

export default isHiddenAt;
